import type { AxiosError, AxiosResponse } from 'axios'

export interface EventParams extends Record<string, string | number | boolean> {}

/**
 * 格式化 axios 错误，转为事件参数
 * @param response
 */
export function formatAxiosError(response: AxiosResponse | AxiosError): EventParams {
  const request = response.request
  let requestUrl = request?.responseURL
  let requestMethod = 'POST'
  let requestData = ''
  if (request && request.httpCollect) {
    const httpCollect = request.httpCollect
    // @mitojs/browser 会重写 xhr 的 open 并添加 httpCollect 对象
    requestUrl = httpCollect.request.url
    requestMethod = httpCollect.request.method
    requestData = httpCollect.request.data || ''
  }
  if (response.config) {
    const config = response.config
    requestMethod = config.method.toUpperCase()
    requestData = config.data || ''
  }
  if (typeof requestData === 'object') {
    requestData = JSON.stringify(requestData)
  }
  const params: EventParams = {
    request_url: requestUrl,
    request_method: requestMethod,
    response_status: response.status || 500
  }
  let responseData = ''
  let errorMessage = ''
  if ('stack' in response) {
    // 如果是 AxiosError
    errorMessage = response.stack
  } else if ('data' in response) {
    // 如果是接口业务错误
    const data = response.data
    responseData = typeof data === 'object' ? JSON.stringify(data) : data
    errorMessage = typeof data === 'object' ? data.rtn_msg || '' : data
  }
  addStringValueToParams(params, 'request_data', requestData)
  addStringValueToParams(params, 'response_data', responseData)
  addStringValueToParams(params, 'error_message', errorMessage)
  return params
}

/**
 * 添加自定义字符串属性，目前用的 ga 收集自定义属性，每个字段有 100 的长度限制，当超过100时，拆分为多个字段，最多10个
 * @param {*} params
 * @param {*} key
 * @param {*} value
 */
function addStringValueToParams(params: EventParams, key: string, value: string) {
  if (value.length <= 100) {
    params[key] = value
  } else {
    const splitLen = Math.min(Math.ceil(value.length / 100), 20)
    for (let i = 0; i < splitLen; i++) {
      params[`${key}_${i}`] = value.substring(i * 100, (i + 1) * 100)
    }
  }
}
